import { 
  SensorRequest, 
  UpdateSensorRequest, 
  SensorQueryParams,
  SensorReading 
} from '../types/sensor.type';
import { HttpMethods, makeRequest } from '../helpers/http.helper';

export const getSensors = (organizationId: string, params: SensorQueryParams) => {
  return makeRequest({
    url: `/sensors/organization/${organizationId}`,
    method: HttpMethods.GET,
    params,
  });
};

export const getSensor = (sensorId: string) => {
  return makeRequest({
    url: `/sensors/${sensorId}`,
    method: HttpMethods.GET,
  });
};

export const createSensor = (sensor: SensorRequest) => {
  return makeRequest({
    url: '/sensors',
    method: HttpMethods.POST,
    data: sensor,
  });
};

export const updateSensor = (sensorId: string, sensor: UpdateSensorRequest) => {
  return makeRequest({
    url: `/sensors/${sensorId}`,
    method: HttpMethods.PUT,
    data: sensor,
  });
};

export const deleteSensor = (sensorId: string) => {
  return makeRequest({
    url: `/sensors/${sensorId}`,
    method: HttpMethods.DELETE,
  });
};

export const getSensorReadings = (sensorId: string, params: { start_date?: string; end_date?: string }) => {
  return makeRequest({
    url: `/sensors/${sensorId}/readings`,
    method: HttpMethods.GET,
    params,
  });
};

export const submitSensorReading = (sensorId: string, reading: SensorReading) => {
  return makeRequest({
    url: `/sensors/${sensorId}/readings`,
    method: HttpMethods.POST,
    data: reading,
  });
};

export const calibrateSensor = (sensorId: string) => {
  return makeRequest({
    url: `/sensors/${sensorId}/calibrate`,
    method: HttpMethods.POST,
  });
};

export const getSensorHealth = (sensorId: string) => {
  return makeRequest({
    url: `/sensors/${sensorId}/health`,
    method: HttpMethods.GET,
  });
};

export const getSensorBatteryStatus = (sensorId: string) => {
  return makeRequest({
    url: `/sensors/${sensorId}/battery`,
    method: HttpMethods.GET,
  });
}; 